export enum STATUS_CODE {
    UNAUTHOR = 401,
    OK = 200,
    NOT_FOUND = 404
}

export const insuranceOptions: string[] = [
    'Gấp 6 lần cước phí vận chuyển',
    'Gấp 5 lần cước phí vận chuyển',
    'Gấp 4 lần cước phí vận chuyển',
    'Gấp 3 lần cước phí vận chuyển',
    'Gấp 2 lần cước phí vận chuyển',
]; 